"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Parent = (function () {
    function Parent() {
    }
    return Parent;
}());
exports.Parent = Parent;
